import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ClientMembers.scss';export default {
  "ClientMembers": "_ClientMembers_b5m73_1",
  "uploadButton": "_uploadButton_b5m73_1"
};